<template>
  <div>
    <navbar>
      <template v-slot:navbarname>
      </template>
    </navbar>
    <!--END Navbar-->

    <h1 class="font-weight-bold">Gallery</h1>

    <b-row>

      <b-col cols="12" md="3">
        <b-card class="sticky-top">
          <div class="content-filter">

            <b-form-group
                class="font-weight-bold"
                label="CATEGORIES">
              <b-input class="mb-3" v-model="searchInputCategory" placeholder="search in categories..."></b-input>
              <b-form-checkbox-group
                  id="checkbox-group-4"
                  :options="getCategoriesSearch"
                  v-model="filter.categoryIds"
                  @change="onSelectFilter"
                  value-field="category_id"
                  text-field="category_title"
                  name="orderStatus"
                  stacked
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </b-card>
      </b-col>
      <!--END Filter-->


      <template v-if="products.length > 0">
        <b-col cols="12" md="9">

          <download-excel
              v-if="productsExport.length"
              :name="'change name'"
              :data="productsExport">
            <b-button variant="success">
              <span>Export to Excel</span>
            </b-button>
          </download-excel>

          <b-card>
            <div class="table-responsive">
              <table class="table">

                <thead class="thead-light">
                <tr>
                  <th>Thumb</th>
                  <th>Cover</th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="(item,index) in products" :key="index">
                  <td>
                    <a target="_blank" :href="item.image_thumb">
                      <img :src="item.image_thumb" alt="Thumb" width="120">
                    </a>
                  </td>
                  <td>
                    <a target="_blank" :href="item.image">
                      <img :src="item.image" alt="Cover" width="120">
                    </a>
                  </td>
                </tr>


                </tbody>



              </table>


            </div>
          </b-card>

          <infinite-loading :identifier="infiniteId" :distance="1"
                            @infinite="getProducts"></infinite-loading>



        </b-col>
      </template>
    </b-row>
    <!--END Products-->

  </div>
</template>

<script>
import Navbar from "../Partials/Navbar";
import Http from '../../Services/HttpService/HttpService'


export default {
  name: "Index",
  components: {
    Navbar
  },
  data() {
    return {
      page: 1,
      infiniteId: +new Date(),
      myFalse: false,
      myTrue: false,
      products: [],
      productsExport: [],
      filter: {
        categories: [],
        categoryIds: [],
      },
      searchInput: null,
      searchInputCategory: null,
    }
  },
  computed:{
    getCategoriesSearch() {
      if (this.searchInputCategory === null) {
        return this.filter.categories;
      }

      return this.filter.categories.filter(item => {
        return item.category_title.toLowerCase().match(this.searchInputCategory.toLowerCase())
      })
    },
  },
  methods:{
    onSelectFilter() {
      this.page = 1;
      this.products = [];
      this.infiniteId += 1;
      this.getProducts();
    },
    getProducts($state) {
      this.$Progress.start();
      this.productsExport=[];
      Http.post(Http.apiurlV2() + 'product/gallery/index?page=' + this.page, {
        categoryIds: this.filter.categoryIds,
      })
          .then(response => {
            if (response.data.status_code === Http.ok()) {

              this.$Progress.finish();

              this.filter.categories = response.data.data.categories;
              this.productsExport = response.data.data.itemsExport;


              if (response.data.data.items.length > 0) {
                this.page += 1;
                this.products.push(...response.data.data.items);
                $state.loaded();
              } else {
                $state.complete();
              }
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    downloadImages(typeFile) {
      this.$Progress.start();
      Http.post(Http.apiurlV2() + 'product/gallery/download', {
        categoryIds: this.filter.categoryIds,
        type: typeFile
      })
          .then(response => {
            console.log("FILE")
            console.log(response.data)


            this.$Progress.finish();

          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
  },
  created() {
    this.getProducts();
  },
}
</script>

<style scoped>

</style>